<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="find"
            :filterable="true"
            :clearable="true"
            :creatable="CCreatable"
            :label="$t('labels.bankAccount')"
            :required="required"
            :multiple="multiple"
            :readonly="readonly"
            :prop="prop"
            :selected-multiple="dataSelectMultiple"
            key-id="_id"
            key-label="bankInfo"
            @create-new="openAdd" />
        <add-bank-account
            ref="addBankAccount"
            @newData="handleNewData" />
    </div>
</template>

<script lang="ts" setup>
import AddBankAccount from '../../pages/trucker-[id]/company/global-settings/bank-account/ignore/add.vue'

import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  dataSelectMultiple: { type: Array, default: () => [] },
  prop: { type: String },
  multiple: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  creatable: { type: Boolean, default: false },
  cooperatorId: { type: String, default: '' },
  name: { type: String, default: '' },
  functionCreateNew: { type: Function, default: null }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click'])

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.partner_commodity_add)) {
    return false
  }
  return true
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const { modelValue, creatable, name, multiple } = toRefs(props)

const find = async (s: string) => {
  const api = $url.settings.findBankAccount
  const res = await $api(api, { query: { key: s } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}

const handleNewData = (data: any) => {
  if (!multiple.value) {
    if (data && data._id) {
      cValue.value = data._id
      cText.value = data.bankName + ' - ' + data.accountNumber
    }
  }
}

const addBankAccount = ref()
const openAdd = () => {
  if (addBankAccount.value) {
    addBankAccount.value.open()
  }
}
</script>
